<template>
    <div v-if="series.length > 0">
        <apexchart type="polarArea"  width="100%" :options="chartOptions" :series="series"></apexchart>
    </div>
</template>
<script>
export default {
    props:['chart', 'seriesToChart'],
    data:() => {
        return{
            timeout:false,
            chartOptions: {
                fill: {
                    colors: ['#D72C83', '#2F80ED', '#FFC700', '#676767', '#775dd0'],
                    opacity: 0.8
                },
                legend:{
                    show: false,
                },
                chart: {
                    toolbar:{
                        show: false,
                    },
                    type: 'pie',
                },
                plotOptions: {
                    pie: {
                        labels: {
                            show: false
                        },
                        expandOnClick: false
                    }
                },
                dataLabels: {
                    enabled: false,
                },
                stroke: {
                    show: false,
                },
                tooltip: {
                    enabled: false
                },


            },
            series: []
        }
    },
    watch:{
        chart:{
            deep:true,
            handler: function () {
                this.timeout = false;
                this.setData();
                setTimeout(() => {
                    this.timeout = true;
                }, 100)
            }
        }
    },
    mounted() {
        setTimeout(() => {
            this.setData();
            this.timeout = true;
        }, 50)
    },
    methods:{
        setData(){
            this.series = this.seriesToChart;
        }
    }
}
</script>
